export default "__VITE_ASSET__DSuJb3pV__"